// IKAIKA: converts the mobile drawer menu's top-level items (Shop, Brand, etc.)
// from a slide-in drill-down panel into an inline accordion.
document.addEventListener(
  'click',
  function (event) {
    var parentLink = event.target.closest('[data-item="parent"]');
    if (!parentLink) return;

    var drawer = parentLink.closest('.drawer-menu');
    if (!drawer) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var item = parentLink.closest('.drawer-menu__item');
    if (!item) return;

    var subList = item.querySelector(':scope > .drawer-menu__list--sub');
    var isOpen = item.classList.contains('is-open-accordion');

    var siblings = item.parentElement ? item.parentElement.children : [];
    for (var i = 0; i < siblings.length; i++) {
      var sibling = siblings[i];
      if (sibling !== item) {
        sibling.classList.remove('is-open-accordion');
        var siblingLink = sibling.querySelector(':scope > [data-item="parent"]');
        var siblingSub = sibling.querySelector(':scope > .drawer-menu__list--sub');
        if (siblingLink) siblingLink.setAttribute('aria-expanded', 'false');
        if (siblingSub) siblingSub.setAttribute('aria-hidden', 'true');
      }
    }

    item.classList.toggle('is-open-accordion', !isOpen);
    parentLink.setAttribute('aria-expanded', String(!isOpen));
    if (subList) subList.setAttribute('aria-hidden', String(isOpen));
  },
  true
);
